import React, { useContext } from "react";

import ViewInitiativeLayout from "../../../organisms/Layouts/layout.view.initiative";
import { H3, P } from "../../../atoms/Texts";

import notSearchedImg from "../../../../assets/images/Curly Arrow.svg";

import { InitiativeReferralsCard } from "../../../atoms/Cards/card.initiative.referrals";

import { demoContext } from "../../../../shared/store/contexts";

const InitiativePendingReferrals = () => {
  const { pendingReferrals } = useContext(demoContext);

  return (
    <ViewInitiativeLayout>
      <div>
        {pendingReferrals?.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {pendingReferrals.map((item) => (
              <InitiativeReferralsCard key={item.id} referral={item} />
            ))}
          </div>
        ) : (
          <>
            <div className="flex flex-col items-center flex-grow justify-center">
              <img src={notSearchedImg} alt="" className="" />
              <H3
                color="#22202D"
                className="mt-6 text-center"
                data-testid="eligibility-text"
              >
                No referral pending
              </H3>
              <P fontSize="16px" color="#7D7B96" className="mt-3 mb-0 text-center">
                Referral would appear when a case has been referred to this
                initiative
              </P>
            </div>
          </>
        )}
      </div>
    </ViewInitiativeLayout>
  );
};

export default InitiativePendingReferrals;
